import _sum from "lodash/sum";
import moment from 'moment';
import { MAX_QUANTITY_TO_BUY, APPAREL_SIZE_NAMES } from './product.constants';
const getApparelSizeName = size => APPAREL_SIZE_NAMES[size] || size;
export let BoxEntities = /*#__PURE__*/function (BoxEntities) {
  BoxEntities["BOX_ONE"] = "box";
  BoxEntities["BOX_MANY"] = "boxes";
  return BoxEntities;
}({});
export const getOne = () => BoxEntities.BOX_ONE;
export const getMany = () => BoxEntities.BOX_MANY;
export const STANDALONE_ITEM_MESSAGES = {
  QUANTITY: {
    getProductMaxByStockLevelMsg: inStock => `Only ${inStock} available for purchase. Please adjust quantity to proceed.`,
    getLEProductNA: () => 'This product is no longer available.',
    getProductOutOfStockMsg: (outOfStockExpireDate = null) => outOfStockExpireDate ? `This product is out of stock (Back in stock date is ${moment(outOfStockExpireDate).format('MMMM Do')}).` : 'This product is no longer available.',
    getProductHiddenMsg: () => 'This product is no longer available.',
    getSomeSkusOutOfStockMsg: () => "You've exceeded stock levels available for this product. Please adjust quantity to proceed.",
    getSelectedSizeOfSimpleProdIsOutOfStockMsg: () => 'This size is out of stock. Please choose another size.'
  },
  REQUIRED_QUANTITY: {
    getProductMsg: unsatisfiedRequiredQuantities => {
      if (Number.isFinite(unsatisfiedRequiredQuantities)) {
        return `You need to increase the amount to ${unsatisfiedRequiredQuantities} or more.`;
      } else if (Array.isArray(unsatisfiedRequiredQuantities)) {
        const arr = unsatisfiedRequiredQuantities.map(object => {
          const size = Object.keys(object)[0];
          const quantity = object[size];
          return `${size} to ${quantity} or more`;
        });
        return `You need to increase the amount of ${arr.join(', ')}.`;
      }
      return '';
    }
  },
  REQUIRED_PARAMS: {
    getItemPrintLocationRemovedMsg: () => 'Set print location is no longer available',
    getItemLogosEmptyMsg: () => 'You need to upload a design'
  }
};
export const BOX_MESSAGES = {
  MIN_QUANTITY: {
    getProductMsg: productMinQnty => `There is a min quantity of ${productMinQnty} for this product`
  },
  QUANTITY: {
    getSomeSizesAreMoreThanAvailable: () => 'Please adjust quantity to proceed',
    getSomeSkusOutOfStockMsg: () => "You've exceeded stock levels available for this product. Please adjust quantity to proceed.",
    quantityPerBoxIsZero: () => 'You should have at least one item per box',
    getProductMaxQntyMsg: maxQuantity => `There is a max quantity of ${new Intl.NumberFormat('en-US').format(maxQuantity)} for this product`,
    getBoxMaxQntyMsg: () => `You cannot order more than ${new Intl.NumberFormat('en-US').format(MAX_QUANTITY_TO_BUY)} boxes`,
    getProductMaxByStockLevelMsg: inStock => `Only ${inStock} available for purchase. Please adjust quantity to proceed.`,
    getBoxProductOutOfStockMsg: (isOrderMore, outOfStockExpireDate = null) => `${outOfStockExpireDate ? `This product is out of stock (Back in stock date is ${moment(outOfStockExpireDate).format('MMMM Do')}).` : 'This product is no longer available.'} You can proceed by removing this product from the box. Please contact us for more information.${isOrderMore ? ' Please note that a new box will be created in your inventory closet.' : ''}`,
    getBoxProductHiddenMsg: () => {
      return 'This product is no longer available. You can proceed by removing this product from the box. Please contact us for more information.';
    },
    totalProductQuantityNotEqualToBoxesQuantity: () => {
      return `Product quantity should match the quantity of ${getMany()}.`;
    },
    totalProductMoreThanAvailableInCart: item => {
      if (!item) {
        return '';
      }
      const {
        quantity,
        availableQuantities
      } = item;
      const quantityPerBox = item.quantityPerBox || 1;
      const notEnoughQuantity = quantity - _sum(availableQuantities);
      return `Hey, in order to have ${quantityPerBox} ${quantityPerBox > 1 ? 'items' : 'item'} in your box, you need to update the remaining in cart to ${notEnoughQuantity}.`;
    },
    totalProductPerSizeMoreThanAvailableInCart: item => {
      const missingSizes = item.variants[0].quantities.reduce((acc, quantityForSize, index) => {
        if (item.availableQuantities && quantityForSize > item.availableQuantities[index]) {
          var _item$prod, _item$prod$size;
          const sizeLabel = (_item$prod = item.prod) === null || _item$prod === void 0 ? void 0 : (_item$prod$size = _item$prod.size) === null || _item$prod$size === void 0 ? void 0 : _item$prod$size.options.find((size, sizeIndex) => sizeIndex === index);
          if (sizeLabel) {
            acc.push(sizeLabel);
          }
          return acc;
        }
        const availableQuantities = item.availableQuantities || [];
        if (quantityForSize > availableQuantities[index]) {
          var _item$prod2;
          const size = ((_item$prod2 = item.prod) === null || _item$prod2 === void 0 ? void 0 : _item$prod2.size) || {
            options: []
          };
          const sizeLabel = size.options.find((size, sizeIndex) => sizeIndex === index);
          acc.push(sizeLabel);
          return acc;
        }
        return acc;
      }, []);
      return `Hey, the quantity of size${missingSizes.length > 1 ? 's' : ''} ${missingSizes.join(', ')} exceeds what you have in your cart. Click on the remaining in cart to adjust.`;
    }
  },
  APPAREL_QUANTITY_RELATED_TO_BOX: {
    getProductMsg: (item, box) => {
      const minItemsQuantityPerBox = box.quantity * item.quantityPerBox;
      const minQuant = item.availableQuantities ? 1 : item.prod.minQuant || 1;
      const minQuantityMessage = new Intl.NumberFormat().format(minItemsQuantityPerBox > minQuant ? minItemsQuantityPerBox : minQuant);
      const secondTextPart = item.quantityPerBox > 1 ? `, since you have ${item.quantityPerBox} items per box` : '.';
      return `The overall item quantity should be ${minQuantityMessage}${secondTextPart}`;
    }
  },
  QUANTITY_PER_BOX: {
    getProductMsg: (item, box) => {
      const {
        quantity
      } = box;
      const {
        quantityPerBox,
        prod: {
          quantIncrement
        }
      } = item;
      const newQuantity = quantity * quantityPerBox;
      const remainder = newQuantity % quantIncrement;
      const proposedQuantity = remainder ? newQuantity + (quantIncrement - newQuantity % quantIncrement) : newQuantity;
      return `You should order at least ${proposedQuantity} items since you have ${quantityPerBox} in each box.`;
    }
  },
  APPAREL_SIZE: {
    getProductMsg: () => 'Quantity sizes need to match your other apparel products',
    differentSizeSet: differentSizeSet => {
      const formattedUnavailableSizes = differentSizeSet.map(size => `"${size}"`);
      const linkingVerb = formattedUnavailableSizes.length > 1 ? "aren't" : "isn't";
      return `Hey! ${formattedUnavailableSizes.join(', ')} ${linkingVerb} available in the other apparel product in your box and all sizes for apparel need to match. Please adjust the size quantities.`;
    },
    getProductAdjustMsg: (wrongSizeQnty, existSize, notExistSize) => `We added ${wrongSizeQnty} to "${getApparelSizeName(existSize)}" because "${getApparelSizeName(notExistSize)}" isn't available in the other apparel product in your box and all sizes for apparel need to match.`
  },
  SUCCESS: {
    getProductMsg: (isKit, qnty) => `There will be ${qnty} product${Number(qnty) > 1 ? 's' : ''} per ${getOne()}`,
    getProductExtraMsg: qnty => `${qnty} will be either added to your inventory or sent to you separately`
  },
  DIVIDABLE_APPAREL_QUANTITY_PER_SIZE: {
    getProductMsg: message => `Apparel products in the ${getOne()} should be of the same size. Make sure sizes can be distributed among boxes. (${message} have incorrect quantities.)`
  },
  QUANTITY_NOT_DIVISIBLE_BY_QUANTITY_INCREMENT: {
    getProductMsg: item => {
      const {
        prod: {
          quantIncrement
        }
      } = item;
      return `Has to be ordered in increments of ${quantIncrement}`;
    }
  },
  FORBIDDEN: {
    getLEProductOrderMoreNA: () => 'This product is not available for re-order.',
    getProductNA: () => 'This product is not available for adding to a box.'
  }
};